import React, { FC, ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  className?: string;
}

const Button: FC<ButtonProps> = ({ text, className, onClick, type, disabled }) => {
  return(
    <div className="flex justify-center w-11/12 ml-6 mb-10 md:justify-end md:mt-10 xl:ml-20 md:ml-16">
      <button type={type} className={`${className}`} onClick={onClick} disabled={disabled}>{text}</button>
    </div>
  );
}

export default Button;